import request from '@/utils/request'

export default {

  loginAccount: ({ userName, password }) => {
    return request.post('/django_rest/onboarding/login', { email_mobile: userName, password: password })
  },

  checkOnboardingPermission: (invitationId) => {
    return request.get('/django_rest/onboarding/check_permission', { params: { invitation_id: invitationId } })
  },

  getInvitationInfo: (invitationId) => {
    return request.get(`/django_rest/onboarding/invitation/${invitationId}`)
  },

  getLoginCodeInfo: ({ loginCode }) => {
    return request.get('/django_rest/onboarding/create_password', { params: { login_code: loginCode } })
  },

  createPassword: ({ loginCode, password, rePassword }) => {
    return request.post('/django_rest/onboarding/create_password', { login_code: loginCode, password1: password, password2: rePassword })
  },

  getOnboardingSteps: (questionnaireId) => {
    return request.get(`/django_rest/onboarding/questionnaire/${questionnaireId}`)
  },

  getStepQuestions: ({ questionnaireId, stepId, invitationId }) => {
    return request.get(`/django_rest/onboarding/step/${stepId}`, { params: { onboarding_page_id: questionnaireId, invitationId: invitationId } })
  },

  answerQuestions: ({ questionnaireId, answers, isLastPage }) => {
    return request.post('/django_rest/onboarding/answer', { onboarding_page_id: questionnaireId, answers: answers, is_last_page: isLastPage })
  },

  forgetOnboardingPassword: (invitationId, email) => {
    return request.post('/django_rest/onboarding/forget_password', { invitation_id: invitationId, email_address: email })
  },

  resetOnboardingPassword: (invitationId, resetCode) => {
    return request.get('/django_rest/onboarding/forget_password', { params: { invitation_id: invitationId, reset_code: resetCode } })
  }
}
